// extracted by mini-css-extract-plugin
export default {"Title":"ErrorView_Title__cdk9Y","SubTitle":"ErrorView_SubTitle__taD2h","ErrorView":"ErrorView_ErrorView__BgD-s"};